
import { DbLead } from '@/lib/types';
import { Lead, LeadStatus, EmailWithType } from '@/types/lead';

export const mapDbLeadToLead = (dbLead: DbLead & {
  notes?: any[];
  documents?: any[];
}): Lead => {
  if (!dbLead) {
    throw new Error('Cannot map null or undefined dbLead to Lead');
  }
  
  // Format email: handle string, object, or array based on what's in the database
  let formattedEmail: string | EmailWithType | EmailWithType[] = '';
  
  if (dbLead.email) {
    if (typeof dbLead.email === 'string') {
      formattedEmail = dbLead.email;
    } else if (Array.isArray(dbLead.email)) {
      formattedEmail = dbLead.email as EmailWithType[];
    } else if (typeof dbLead.email === 'object') {
      formattedEmail = dbLead.email as EmailWithType;
    }
  }

  return {
    id: dbLead.id,
    name: dbLead.name,
    address: dbLead.address || '',
    category: dbLead.category || '',
    email: formattedEmail,
    phone: dbLead.phone || '',
    website: dbLead.website || '',
    imageUrl: dbLead.image_url || '',
    isFavorite: dbLead.is_favorite || false,
    rating: dbLead.rating || 0,
    reviewCount: dbLead.review_count || 0,
    status: (dbLead.status || 'new') as LeadStatus,
    notes: dbLead.notes 
      ? dbLead.notes.map(note => ({
          id: note.id,
          content: note.content,
          createdAt: note.created_at,
          updatedAt: note.updated_at || note.created_at,
          createdBy: note.created_by,
          tags: note.tags || [], // Ensure tags is always an array
        }))
      : [],
    documents: dbLead.documents 
      ? dbLead.documents.map(doc => ({
          id: doc.id,
          name: doc.name,
          url: doc.url,
          type: doc.type || '',
          description: doc.description || '',
          leadId: doc.lead_id,
          createdAt: doc.created_at,
          uploadedBy: doc.uploaded_by || undefined,
        }))
      : [],
    createdAt: dbLead.created_at,
    updatedAt: dbLead.updated_at,
    companyId: dbLead.company_id,
    placeId: dbLead.place_id || '',
    createdBy: dbLead.created_by || '',
    images: [], // This will be filled separately by getLeadImages
    webSearchData: dbLead.web_search_data,
    webSearchUpdatedAt: dbLead.web_search_updated_at,
    webSearchStatus: dbLead.web_search_status || 'pending',
    webSearchQueueTime: dbLead.web_search_queue_time || null,
    webSearchRetryCount: (dbLead as any).web_search_retry_count || 0,
    webSearchLastError: (dbLead as any).web_search_last_error || null,
    combinedData: dbLead.combined_data,
    combinedUpdatedAt: dbLead.combined_updated_at,
    keyContacts: [], // This will be filled separately by getKeyContacts
    deepResearchStatus: (dbLead as any).deep_research_status || null,
    deepResearchUpdatedAt: (dbLead as any).deep_research_updated_at || null,
    crawlStatus: (dbLead as any).crawl_status || null,
    crawlUpdatedAt: (dbLead as any).crawl_updated_at || null,
    sector: (dbLead as any).sector || undefined,
    
    // Handle latitude and longitude properties safely using type assertion
    latitude: (dbLead as any).latitude || undefined,
    longitude: (dbLead as any).longitude || undefined,
    lastContactedAt: (dbLead as any).last_contacted_at || null,
  };
};
